import { createOscillation, createRandomInRange } from '@/utils/math';
import * as THREE from 'three';

export type animationType = 'floatUp' | 'shake';

export type PointOptions = {
    /**
     * 中心位置
     */
    originPosition?: THREE.Vector3;
    /**
     * 初始位置
     */
    initPosition: THREE.Vector3;
    /**
     * 颜色
     */
    color?: number;
    /**
     * 尺寸
     */
    size?: number;
    /**
     * 透明度
     */
    opacity?: number;    
    /**
     * 动画类型
     */
    animation: animationType;
}

export default class Point {
    originPosition: THREE.Vector3;
    position: THREE.Vector3;
    timestamp: number = 0;
    size: number = 1;
    opacity: number = 1;
    color: number = 1;
    update: (timestamp: number, delta: number) => void;
    needClear: boolean = false;
    constructor({ originPosition, initPosition, color, animation, size, opacity }: PointOptions) {
        this.position = initPosition;
        this.originPosition = originPosition || new THREE.Vector3(0, 0, 0);
        if (size) this.size = size;
        if (color) this.color = color;
        if (opacity) this.opacity = opacity;

        this.update = this.createAnimation(animation);
    }

    getPosition(): [number, number, number] {
        return [ this.position.x, this.position.y, this.position.z ];
    }

    createAnimation = (animation: animationType) => {
        const shake = this.createShake();
        const flash = this.createFlashing();
        const floatUp = this.createFloatUp();
        return (...args: Parameters<typeof shake>) => {
            // shake(...args);
            floatUp(...args);
            // flash(...args);
        }
    }

    createShake = () => {
        const radius = 0.1;
        const speed = createRandomInRange(0.001, 0.002);
        let passTime = 0;
        // const oscillation = createOscillation(0, 1, speed);
        const initPosition = this.position.clone();
        const progress = 0.5;
        return (timestamp: number, deltaTime: number) => {
            passTime += timestamp;
            const angle = (timestamp * speed) % 2 * Math.PI;
            // const { progress } = oscillation();
            const x = radius * Math.cos(angle) * progress;
            const y = radius * Math.sin(angle) * progress;
            const z = Math.sqrt(radius ** 2 - x ** 2 - y ** 2) * progress;
            this.position.x = initPosition.x + x;
            this.position.y = initPosition.y + y;
            this.position.z = initPosition.z + z;
        }
    }

    createFloatUp = () => {
        const amplitude = createRandomInRange(0.1, 0.5);
        const period = createRandomInRange(5, 8)
        const upSpeed = createRandomInRange(1, 2);
        let passTime = 0;
        let originX: number | undefined = undefined;
        return (timestamp: number, deltaTime: number) => {
            if (this.position.y > 8) return this.needClear = true;
            if (!this.timestamp) this.timestamp = timestamp;
            if (!originX) originX = this.position.x;
            deltaTime = deltaTime / 1000;
            passTime += deltaTime;
            this.position.y += upSpeed * deltaTime;
            this.position.x = originX + amplitude * Math.sin(2 * Math.PI * (passTime / period));
        }
    }

    createFlashing = () => {
        const maxLumen = 1;
        let speed = createRandomInRange(0.01, 0.05);
        let isFreeze = false;
        let freezeTimestamp: undefined | number = undefined
        const freezeTime = createRandomInRange(500, 2000);
        const oscillation = createOscillation(0, maxLumen, speed, freeze);
        function freeze(timestamp: number) {
            isFreeze = true;
            freezeTimestamp = timestamp;
        }
        return (timestamp: number, deltaTime: number) => {
            if (freezeTimestamp && isFreeze && (timestamp - freezeTimestamp) < freezeTime) return;
            const { progress } = oscillation(timestamp);
            this.opacity = progress;
        }
    }
}